import * as React from 'react';
import classNames from 'classnames';

export const TdComponent: React.ElementType = ({ toggleSort, className, children, ...rest }) => (
  <div className={classNames('rt-td', className)} role="gridcell" {...rest}>
    <span className="cellContent">{children}</span>
  </div>
);
